module.exports = __webpack_public_path__ + "img/bck.b000e1e7.png";